package com.bulut.mecitogullari.data.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map

/**
 * All app data lives under `users/{uid}/...` in Firestore, so each
 * contractor only ever sees their own ledger.
 */

internal fun currentUid(): String? = Firebase.auth.currentUser?.uid

internal fun userDoc(uid: String): DocumentReference =
    Firebase.firestore.collection("users").document(uid)

internal fun userCollection(uid: String, name: String): CollectionReference =
    userDoc(uid).collection(name)

/**
 * Live contents of a user-scoped collection; re-binds when the signed-in
 * user changes and empties out on sign-out.
 */
@OptIn(ExperimentalCoroutinesApi::class)
internal inline fun <reified T : Any> userCollectionFlow(name: String): Flow<List<T>> =
    Firebase.auth.authStateChanged.flatMapLatest { user ->
        if (user == null) {
            flowOf(emptyList())
        } else {
            userCollection(user.uid, name).snapshots.map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    runCatching { doc.data<T>() }.getOrNull()
                }
            }
        }
    }
